import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=1eae2db0&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=1eae2db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae2db0",
  null
  
)

export default component.exports